import React, { useEffect, useState } from 'react';
import ConfigDB from '../../Config/ThemeConfig';
import Context from './index';

const CustomizerProvider = (props) => {
  const customizer = ConfigDB.data;
  const [layout, setLayout] = useState('');
  const [sidebarIconType, setSidebarIconType] = useState('');
  const [toggleIcon, setToggleIcon] = useState(false);
  const [mixLayout, setMixLayout] = useState(false);
  const [IsOpen, setIsClose] = useState(false);
  const layoutValue = 'compact-wrapper dark-sidebar';

  useEffect(() => {
    setLayout(layoutValue);
    setSidebarIconType(localStorage.getItem('sidebar_icon_type') || ConfigDB.data.settings.sidebar.iconType);
    ConfigDB.data.settings.sidebar_setting = 'default-sidebar';

    document.documentElement.style.setProperty('--theme-default', ConfigDB.data.color.primary_color);
    document.documentElement.style.setProperty('--theme-secondary', ConfigDB.data.color.secondary_color);
  }, []);

  const toggleSidebar = (toggle) => {
    setToggleIcon(toggle);
  };

  return (
    <Context.Provider
      value={{
        ...props,
        layout,
        sidebarIconType,
        toggleIcon,
        mixLayout,
        IsOpen,
        customizer,
        setIsClose,
        setToggleIcon,
        setMixLayout,
        toggleSidebar: toggleSidebar,
      }}>
      {props.children}
    </Context.Provider>
  );
};

export default CustomizerProvider;
